import type { I18n } from '@learnforge/i18n';

export interface ActionBarButton {
  id: string;
  labelKey: string;
  onClick(): void;
  disabled?: boolean;
}

export interface ActionBarOptions {
  buttons: ActionBarButton[];
  i18n: I18n<string>;
}

export interface ActionBarHandle {
  setLabel(id: string, labelKey: string): void;
  setDisabled(id: string, disabled: boolean): void;
  setActive(id: string, active: boolean): void;
  destroy(): void;
}

export function createActionBar(host: HTMLElement, opts: ActionBarOptions): ActionBarHandle {
  const bar = document.createElement('div');
  bar.className = 'tg-action-bar';
  host.appendChild(bar);

  const labelKeys = new Map<string, string>();
  for (const b of opts.buttons) {
    const btn = document.createElement('button');
    btn.dataset.id = b.id;
    btn.textContent = opts.i18n.t(b.labelKey);
    btn.disabled = !!b.disabled;
    btn.addEventListener('click', () => b.onClick());
    bar.appendChild(btn);
    labelKeys.set(b.id, b.labelKey);
  }

  return {
    setLabel(id, labelKey) {
      const btn = bar.querySelector(`button[data-id="${id}"]`);
      if (btn) btn.textContent = opts.i18n.t(labelKey);
      labelKeys.set(id, labelKey);
    },
    setDisabled(id, disabled) {
      const btn = bar.querySelector<HTMLButtonElement>(`button[data-id="${id}"]`);
      if (btn) btn.disabled = disabled;
    },
    setActive(id, active) {
      const btn = bar.querySelector<HTMLButtonElement>(`button[data-id="${id}"]`);
      if (btn) btn.dataset.active = active ? 'true' : 'false';
    },
    destroy() {
      bar.remove();
    },
  };
}
